export const getError = (error: any) => {
  const response = error.response || {};
  const data = response.data || {};
  const isBadRequest = response.status === 400 || response.status === 500;
  let errorMessage: any;

  if (isBadRequest) {
    let { errors } = data;
    const hasMultipleMessages = Array.isArray(data.errors) && typeof data.errors[0] === "object";

    if (errors && hasMultipleMessages) {
      const errorsMessage = data.errors.map((x) => x.detail);

      errors = errorsMessage.join("\r\n");
    }
    errorMessage = errors;
  }
  return errorMessage;
};

export const hasError = (error: any) => {
  return error.response;
};
